<i
  class="pi"
  [class.qs-ico-ship]="kind() === locationKind.port"
  [class.qs-ico-train]="kind() === locationKind.railTerminal"
  [class.qs-ico-plane]="kind() === locationKind.airport"
  [class.qs-ico-truck]="kind() === locationKind.roadTerminal"
  [class.qs-ico-location-group]="locationGroup()"
>
</i>
